// this is for any GSAP related anims
import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
// import { ScrollToPlugin } from 'gsap/ScrollToPlugin.js';
import { Draggable } from 'gsap/Draggable.js';

let ScrollTriggerInit = gsap.registerPlugin( ScrollTrigger, Draggable );

if( $( '.webgl-container' ).length ) {
  ScrollTriggerInit;
  let sections = gsap.utils.toArray('.section');
  var container = $('.webgl-container');
  var nav = $('.nav');
  var scrollColor = document.querySelectorAll("[data-color]");

  ScrollTrigger.create({
    trigger: container,
    start: 'top top',
    end: 'bottom top',
    onEnter: () => $( nav ).addClass( 'nav-lock' ),
    onEnterBack: () => $( nav ).addClass( 'nav-lock' ),
    onLeave: () => $( nav ).removeClass( 'nav-lock' ),
    onLeaveBack: () => $( nav ).removeClass( 'nav-lock' ),
  });  

  scrollColor.forEach(function (colorSection, i) {
    var defaultColor = scrollColor[0].dataset.color;
    var prevColor = i === 0 ? defaultColor : scrollColor[i - 1].dataset.color;
    ScrollTrigger.create({
      trigger: colorSection,
      start: "top 40%",
      onEnter: function onEnter() {
        return gsap.to(".bg-swap", {
          backgroundColor: colorSection.dataset.color,
          overwrite: 'auto'
        });
      },
      onLeaveBack: function onLeaveBack() {
        return gsap.to(".bg-swap", {
          backgroundColor: prevColor,
          overwrite: 'auto'
        });
      }
    });
  });

}

//scrolling sidebar nav 
if( $( '.sidebar-nav' ).length ) {
  ScrollTriggerInit;
  const navLinks = gsap.utils.toArray( '.sidebar-nav a' );   
  const panels = gsap.utils.toArray( '.sidebar-item' );

  panels.forEach( ( elem, i ) => { 
    ScrollTrigger.create( {
      trigger: elem,
      start: 'top 151', //151px because the side-nav is designed to scroll to the top-150px 
      end: 'bottom 151',
      invalidateOnRefresh: true,
      toggleClass: {targets: navLinks[i], className: 'active'},
    });
  });
  //recalculate the dom positions of each panel after page load
  setTimeout( () => {
    ScrollTrigger.refresh()
  }, 1500 ) 
  //recalculate the dom positions of each panel after accordion open/close
  $( '.accordion' ).on( 'click', function() {
    setTimeout( () => {
      ScrollTrigger.refresh()
    }, 250 ) 
  });

  $( '.sidebar-nav-link' ).on( 'click', function( e ) {
    e.preventDefault();
    var id = $(this).attr( 'href' );
    $( 'html,body' ).animate({ scrollTop: $( id ).offset().top -150 }, 270 );
  });
}

$( function() {
  if ( $( '[data-slide-up]' ).length ) {
      ScrollTriggerInit;
      let slideUp = document.querySelectorAll( '[data-slide-up]' );

      slideUp.forEach((elem, i) => {
        ScrollTrigger.create({
          trigger: elem,
          start:"top-=100% bottom",
          end:"bottom-=100% top",
          onEnter: () => $(elem).addClass('slide-up'),
          onLeaveBack: () => $(elem).removeClass('slide-up'),
          onEnterBack: () => $(elem).addClass('slide-up'),
        });
      });
  }
  if ( $( '[data-slide-right]' ).length ) {
      ScrollTriggerInit;
      let slideUp = document.querySelectorAll( '[data-slide-right]' );

      slideUp.forEach((elem, i) => {
        ScrollTrigger.create({
          trigger: elem,
          start:"top bottom-=50px", 
          onEnter: () => $(elem).addClass('slide-right'),
          onLeaveBack: () => $(elem).removeClass('slide-right'),
          onEnterBack: () => $(elem).addClass('slide-right'),
        });
      });
  }
  if ( $( '[data-fadein]' ).length ) {
      ScrollTriggerInit;
      let fadeIn = document.querySelectorAll( '[data-fadein]' );

      fadeIn.forEach((elem, i) => {
        ScrollTrigger.create({
          trigger: elem,
          start:"top bottom-=50px", 
          onEnter: () => $(elem).addClass('fade-in'),
          onLeaveBack: () => $(elem).removeClass('fade-in'),
          onEnterBack: () => $(elem).addClass('fade-in'),
        });
      });
  }
  if ( $( '.drop-in-item' ).length ) {
      ScrollTriggerInit;
      let dropIn = document.querySelectorAll( '.drop-in-item' );

      dropIn.forEach((elem, i) => {
        ScrollTrigger.create({
          trigger: elem,
          start:"bottom bottom-=100px",
          onEnter: () => $(elem).addClass('drop-in')
        });
      });
  }
})

if( $( '.webgl-container' ).length ) {
  setTimeout( () => {
    ScrollTrigger.refresh( true )
  }, 1500 ) 
}

if( $( '.slider' ).length ) {
  setTimeout( () => {
    ScrollTrigger.refresh( true )
  }, 1500 ) 
}
if( $( '.js-sort' ).length ) {
  $( '.js-sort a' ).on( 'click', function ( e ) {
    ScrollTrigger.refresh( true );
    $('.fade-item').css( 'transition-delay', '0.2s');
  })
}
if( $( '.js-tag' ).length ) {
  $( '.js-tag input' ).on( 'click', function ( e ) {
    ScrollTrigger.refresh( true );
    $('.fade-item').css( 'transition-delay', '0.2s');
  })
}
